import React, { useEffect, useState, useRef } from 'react';
import { connect, useDispatch } from 'react-redux';
import { CircularProgress } from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';

import { server } from "../../store/globalSettings";
import { logoutUser, switchUser } from '../../store/actions';

import Notification from '../../components/Common/Notification';

const RedirectPage = ({ switchUserRes }) => {

    const { token } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [notification, setNotification] = useState({
        open: false,
        msg: "",
        type: "success",
    });

    const switchTimeoutRef = useRef(null);
    const SWITCH_TIMEOUT = 10000; // ms
    const hasRunRef = useRef(false);
    const loginTimeoutRef = useRef(null);

    const triggerSwitchUser = () => {
        // only set token if we have one from URL
        if (token) {
            // store as JSON so other code that does JSON.parse(...) can read it
            localStorage.setItem("token", JSON.stringify(token));
        }
        const tokenParam = localStorage.getItem("token")
        if (tokenParam) {
            dispatch(switchUser({ data: { type: "personal" }, notDirectToLogin: true }));
        }
        else {
            setNotification({ open: true, msg: 'No token found for switching user', type: 'error' });
            // navigate to login after 6 seconds
            if (loginTimeoutRef.current) clearTimeout(loginTimeoutRef.current);
            loginTimeoutRef.current = setTimeout(() => navigate('/login'), 6000);
        }
    };

    useEffect(() => {
        if (hasRunRef.current) return;
        hasRunRef.current = true;

        // const tokenParam = localStorage.getItem("token")

        // if (tokenParam) {
            // If token present in localStorage: logout current session first,
            // then set the new token and trigger switchUser.
            // dispatch(logoutUser({ notDirectToLogin: true }));
            triggerSwitchUser();
        //     return
        // } else {
        //     // If no token present: trigger switchUser directly.
        //     triggerSwitchUser();
        // }

        // cleanup timers on unmount
        return () => {
            if (switchTimeoutRef.current) clearTimeout(switchTimeoutRef.current);
            if (loginTimeoutRef.current) clearTimeout(loginTimeoutRef.current);
        };
    }, []);

    // navigate to dashboard when switchUserRes indicates success
    useEffect(() => {
        if (switchUserRes && switchUserRes?.user?.code === "success") {
            localStorage.setItem('selected_account_id', switchUserRes?.user?.data?.profile?.id);
            navigate('/dashboard');
        } else if(switchUserRes?.user?.code && switchUserRes?.user?.code !== "success") {
            setNotification({ open: true, msg: switchUserRes?.user?.message || 'Error switching user', type: 'error' });
            if (loginTimeoutRef.current) clearTimeout(loginTimeoutRef.current);
            loginTimeoutRef.current = setTimeout(() => navigate('/login'), 6000);
        }
    }, [switchUserRes]);

    const containerStyle = {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 20,
    };

    const cardStyle = {
        padding: '32px 40px',
        borderRadius: 12,
        textAlign: 'center',
        maxWidth: 720,
        width: '100%'
    };

    const titleStyle = {
        margin: '12px 0 8px',
        fontSize: 20,
        color: '#1d1b1b'
    };

    const subtitleStyle = {
        margin: 0,
        color: '#6b7280'
    };

    return (
        <div style={containerStyle}>

            <Notification
                notification={notification}
                setNotification={setNotification}
            />

            <div style={cardStyle}>
                <CircularProgress size={48} color="inherit" />

                <h2 style={titleStyle}>
                    Redirecting to login
                </h2>

                <p style={subtitleStyle}>
                    Please wait a moment — you will be redirected automatically.
                </p>
            </div>

        </div>
    );
};


function mapStateToProps({ Login, Layout, Accessory, General }) {

    return {
        switchUserRes: Login?.switchUserRes,

    };
}


export default connect(mapStateToProps)(RedirectPage);